<template>
  <div>
    <div class="input-group" style="width: 100px;">
      <input type="text" data-error="#err-day-time-start" class="form-control form_datetime_time_only no-focus" :class="{'is-invalid': layoutData.errorText != null}" @change="onChange" v-model="valueData" />
      <span class="input-group-btn">
        <button class="btn default" type="button">
          <i class="fa fa-clock-o"></i>
        </button>
      </span>
    </div>
    <div id="err-day-time-start"></div>
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-duration",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      }
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>